import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useStrictLocalization } from "@faire/web/common/localization";
import { QuickActionType } from "../types";
export var useBrandQuickActions = function useBrandQuickActions() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var requestCommissionChange = {
    id: QuickActionType.REQUEST_COMMISSION_CHANGE,
    label: strictLocalize({
      id: "rDhZN2",
      defaultMessage: "Request commission change"
    })
  };
  var editItemAvailability = {
    id: QuickActionType.EDIT_ITEM_AVAILABILITY,
    label: strictLocalize({
      id: "PbtIZ5",
      defaultMessage: "Edit item availability"
    })
  };
  var cancelAnOrder = {
    id: QuickActionType.CANCEL_AN_ORDER,
    label: strictLocalize({
      id: "C20NsF",
      defaultMessage: "Cancel an order"
    })
  };
  var acceptAnOrder = {
    id: QuickActionType.ACCEPT_AN_ORDER,
    label: strictLocalize({
      id: "i03Kwu",
      defaultMessage: "Accept an order"
    })
  };
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, QuickActionType.REQUEST_COMMISSION_CHANGE, requestCommissionChange), QuickActionType.EDIT_ITEM_AVAILABILITY, editItemAvailability), QuickActionType.CANCEL_AN_ORDER, cancelAnOrder), QuickActionType.ACCEPT_AN_ORDER, acceptAnOrder);
};